{
  "calculation.addendum.exceedsIndicativeAmount": "Der er behov for individuel prisfastsættelse af en medarbejder i Finans.",
  "calculation.compare": "Sammenlign beregninger",
  "calculation.compare.close": "Luk sammenligning",
  "calculation.compare.select.subheader": "Vælg de aftaler, der skal sammenlignes.",
  "calculation.compare.subheader": "Her kan du sammenligne de valgte aftaler.",
  "calculation.createContract": "Indgå aftale",
  "calculation.delete": "Slet beregning",
  "calculation.delete.confirm.description": "Det vil ikke være muligt at genfinde beregningen via Låneportalen. Er du sikker på, at du vil forsætte?",
  "calculation.delete.confirm.title": "Du er ved at slette en beregning",
  "calculation.edit": "Rediger beregning",
  "calculation.expirationDate": "Udløbsdato",
  "calculation.export.plural": "Eksporter beregninger",
  "calculation.forceInterestAgreement": "Gennemtving",
  "calculation.forceInterestAgreement.modal.description": "Du er ved at gennemtvinge renteaftalen for aftale {{ contractId }}. Fortsætter du, fastsættes renten og sagens tilstand skifter til færdigbehandlet.",
  "calculation.forceInterestAgreement.modal.spread": "KK-Tillæg",
  "calculation.forceInterestAgreement.modal.title": "Gennemtving renteaftale",
  "calculation.forceInterestAgreement.modal.warning": "Øvrige vilkår i henhold til låneaftalen forbliver uændret. Handlingen er bindende og kan ikke fortrydes.",
  "calculation.forceInterestAgreement.notImplemented": "Not Yet Implemented",
  "calculation.gracePeriod": "Afdragsfrihed",
  "calculation.interestAgreementExpirationDate": "Udløb renteaftale",
  "calculation.interestPaymentDate": "Første rentebetaling",
  "calculation.interestPaymentFrequency": "Rentefrekvens",
  "calculation.marketDataTimeStamp": "Markedsdata opdateret: {{ date, dateTime }}",
  "calculation.maxAmount.message": "Du kan maksimum lave 8 beregninger. For at lave nye beregninger skal du slette nogle eksisterende beregninger.",
  "calculation.maxAmount.title": "Højeste antal beregninger opnået",
  "calculation.newLoan.summary": "{{ loanProduct }}, {{ amount, currency }} DKK, {{ years }} år",
  "calculation.newLoan.title": "Estimer nyt udlån",
  "calculation.originalContract": "Oprindelig aftale",
  "calculation.performCalculation": "Lav beregning",
  "calculation.ratePaymentMethod": "Metode til rentebetaling",
  "calculation.ratePaymentMethod.creditDraw": "Opskriv kredittræk",
  "calculation.ratePaymentMethod.payInterest": "Betal renter",
  "calculation.redemption.summary": "{{ eventDescription }}, {{ amount, currency }} DKK, {{ date, date }}, {{ repaymentMethod }}",
  "calculation.redemption.title": "Beregning af indfrielse",
  "calculation.selectAmortizationProfile": "Vælg afdragsprofil",
  "calculation.selectLoanType": "Vælg aftaletype",
  "calculation.selectPaymentDate": "Udbetalingsdato",
  "calculation.selectRatePaymentMethod": "Vælg metode til rentebetaling",
  "calculation.selectTerm": "Vælg termin",
  "calculation.send": "Send beregning",
  "calculation.send.success": "Beregning afsendt",
  "calculation.timestamp": "Beregning udført: {{ date, dateTime }}",
  "calculation.title": "$t(common:calculation_one)",
  "calculation.update.success": "Beregningen er opdateret",
  "compensation.amount.warning.exceedsMax": "{{eventDescription}} overstiger DKK {{amount, currency}}. Kompenstationsbeløbet skal derfor individuelt prisfastsættes.",
  "form.input.exceedsMax": "Overstiger maksimum",
  "form.input.maxLength": "Maksimum {{ maxLength }} tegn",
  "form.input.required": "Feltet er påkrævet",
  "installment.amount": "Afdragsbeløb",
  "installment.amount.error.exceedsRemainingDebt": "Afdragsbeløbet overskrider restgælden på {{amount, currency}} DKK på den valgte dato. Vælg nyt beløb eller dato.",
  "installment.amount.error.minimum": "Afdragsbeløbet skal være mindst {{amount, currency}} DKK",
  "installment.amount.tooltip.minimum": "Min. beløb {{amount, currency}} DKK",
  "installment.amount.warning.exceedsIndicative.title": "Individuel prisfastsættelse",
  "installment.edit": "Rediger afdragsoplysninger",
  "installment.firstPayment": "Første afdrag",
  "leasing.fixedFirstPayment": "Ekstraordinær leasingydelse",
  "leasing.fixedFirstPayment.error.mustNotExceedPrincipal": "Ekstraordinær leasingydelse må ikke overskride finansieringssum",
  "leasing.form.title": "Beregn leasingydelse",
  "leasing.interestInformation": "Renteoplysninger",
  "leasing.interestPaymentFrequency": "Betalingsfrekvens",
  "leasing.interestRate": "Aftalerente",
  "leasing.loanProduct": "Renteprodukt",
  "leasing.loanProduct.error.required": "Renteprodukt er påkrævet",
  "leasing.downloadCalculationCsv": "Download beregning (CSV)",
  "leasing.notionalAmount": "Restgæld",
  "leasing.numberOfPayments": "Antal leasingydelser",
  "leasing.numberOfPayments.error.required": "Antal leasingydelser er påkrævet",
  "leasing.ordinaryPayment": "Ordinær leasingydelse",
  "leasing.payment": "Leasingydelse",
  "leasing.principalAmount": "Finansieringssum",
  "leasing.principalAmount.error.required": "Finansieringssum er påkrævet",
  "leasing.principalValueDate": "Dato for første leasingydelse",
  "leasing.principalValueDate.error.required": "Dato for første leasingydelse er påkrævet",
  "leasing.scrap": "Restværdi",
  "leasing.scrap.error.mustNotExceedPrincipal": "Restværdi må ikke overskride finansieringssum",
  "leasing.scrap.error.required": "Restværdi er påkrævet",
  "leasing.selectLoanProduct": "Vælg renteprodukt",
  "leasing.selectPrincipalValueDate": "Vælg måned og år",
  "leasing.writeTerms": "Angiv antal leasingydelser",
  "leasing.input.onTopSpread": "Leasingtillæg (basispunkter)",
  "leasing.onTopSpread": "Leasingtillæg",
  "leasing.onTopSpread.error.required": "Leasingtillæg er påkrævet",
  "rate.amount.warning.exceedsMax": "{{eventDescription}} overstiger DKK {{amount, currency}}. Renten skal derfor individuelt prisfastsættes.",
  "redemption.date": "Afdragsdato",
  "redemption.date.notified.message": "Hvis indfrielsen kræver kreditering, så gøres dette automatisk ved eksekvering",
  "redemption.date.notified.title": "Ydelsen er adviseret den {{ date, date }}",
  "redemption.date.outOfTerm": "$t(calculation:redemption.date) uden for termin",
  "redemption.date.payDate": "$t(common:valueDate): {{ date, date }}",
  "send.calculation.plural": "Send beregninger",
  "standalone.averageDuration": "Gennemsnitlig løbetid",
  "standalone.calculationType": "Beregningstype",
  "standalone.creditMax.error.required": "Kreditmaksimum er påkrævet",
  "standalone.date.error.invalid": "Datoer skal indtastes i formatet DD.MM.ÅÅÅÅ",
  "standalone.determineAtTerm": "Fastsættes ved termin",
  "standalone.durationInYears": "Løbetid i antal år",
  "standalone.existingContract": "Eksisterende aftale",
  "standalone.existingContract.placeholder": "Søg aftale",
  "standalone.firstPayDateUnadjusted.error.afterMaturityDate": "Første rentebetaling skal ligge før udløbsdato",
  "standalone.firstPayDateUnadjusted.error.required": "Første rentebetaling påkrævet",
  "standalone.firstPayment": "Første ydelse",
  "standalone.fixedInterestPeriodType": "Rentebinding",
  "standalone.fixedInterestPeriodType.cheapest": "Billigste renteaftale",
  "standalone.fixedInterestPeriodType.cibor": "Rentebinding (KK-tillæg)",
  "standalone.fixedInterestPeriodType.error.lesserThanMaturityDate": "Den valgte rentebinding overskrider udløbsdatoen {{ date }}. Vælg ny udløbsdato eller rentebinding.",
  "standalone.fixedInterestPeriodType.error.required": "Rentebinding er påkrævet",
  "standalone.fixedInterestPeriodType.valueWithQualifier": "{{ years }} år ({{ qualifier }})",
  "standalone.fixedInterestPeriodType.wholeLoanPeriod": "Hele løbetiden",
  "standalone.fundingSpread": "Funding spread",
  "standalone.indicativeRate": "Indikativ rente pr. {{ date, date }}",
  "standalone.interestPaymentFrequency.error.required": "Rentefrekvens er påkrævet",
  "standalone.loanProduct": "Produkttype",
  "standalone.loanProduct.error.required": "Produkttype er påkrævet",
  "standalone.margin": "Aktuel bidragssats",
  "standalone.maturityDateUnadjusted.error.beforePrincipalValueDate": "Udløbsdato skal være senere end Udbetalingsdato",
  "standalone.maturityDateUnadjusted.error.exceedsMax": "Udløbsdatoen overskrider grænsen på 40 år",
  "standalone.maturityDateUnadjusted.error.required": "Udløbsdato er påkrævet",
  "standalone.maturityDateUnadjusted.tooltip": "Valg af udløbsdato er ikke begrænset til bankdage, men skal ligge i fremtiden. Ved valg af ikke-bankdag, justeres sidste betaling til en bankdag.",
  "standalone.newInterestAgreement": "Ny renteaftale",
  "standalone.newInterestAgreement.error.loanNotFound": "Aftalen findes ikke",
  "standalone.newInterestAgreement.error.loanNotValid": "Ingen ny rentebinding påkrævet",
  "standalone.newInterestAgreement.error.submit": "Der skal være fundet en aftale for at lave beregning",
  "standalone.newInterestAgreement.loanFound": "Aftale fundet",
  "standalone.newLoan": "Nyt lån",
  "standalone.principalAmount.error.required": "Hovedstol er påkrævet",
  "standalone.principalValueDate.error.required": "Udbetalingsdato påkrævet",
  "standalone.selectInstalmentFreeTerms": "Vælg antal terminer",
  "standalone.selectLoanProduct": "Vælg produkttype",
  "standalone.selectNumberOfYears": "Vælg antal år",
  "standalone.startupCosts": "Etableringsomkostninger",
  "toast.calculation.deleted": "Beregningen er slettet",
  "toast.calculation.success": "Beregningen er udført"
}
